import { Hours, Milliseconds, Minutes, Seconds } from '../models/custom-types';

export class DateUtils {
  static readonly MILLISECONDS: Milliseconds = 1;
  /** Ilość milisekund w sekundzie */
  static readonly SECONDS: Seconds = 1000 * DateUtils.MILLISECONDS;
  /** Ilość milisekund w minucie */
  static readonly MINUTES: Minutes = 60 * DateUtils.SECONDS;
  /** Ilość milisekund w godzinie */
  static readonly HOURS: Hours = 60 * DateUtils.MINUTES;

  static calculateAge(birthDate: Date | null | undefined): number {
    const today = new Date();
    if (birthDate === null || birthDate === undefined) {
      return -1;
    }
    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }
}
